import { render } from "./panelParameter.vue?vue&type=template&id=42755546&scoped=true"
import script from "./panelParameter.vue?vue&type=script&lang=js"
export * from "./panelParameter.vue?vue&type=script&lang=js"

import "./panelParameter.vue?vue&type=style&index=0&id=42755546&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42755546"]])

export default __exports__